module.exports = "<div>\n  <app-new-page [pageTitle]=\"page.title\" [pageSlug]=\"page.slug\"></app-new-page>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/about-city/about-city.component.html
// module id = ../../../../../src/app/event/about-city/about-city.component.html
// module chunks = main